import type { Step } from "react-joyride";

export const homepageTourSteps: Step[] = [
  {
    target: "#schedule-meeting-button",
    content:
      "Ready to book? Click here to schedule a new meeting with your clients. You can set the date, time, meeting type, and add relevant details all in one place.",
    placement: "bottom",
    title: "Schedule New Meeting",
    disableBeacon: true,
  },
  {
    target: "#meetings-panel",
    content:
      "View all your scheduled meetings with complete details including status, date, time, meeting type, and links. Use the filters to quickly find the meetings you need.",
    placement: "left",
    title: "Your Meeting Schedule",
    disableBeacon: true,
  },
];
